import React from 'react';

import { useSelector } from 'react-redux';

import { userSelector } from '../reducers/current-user-selectors';

import { AutomationTimelineBlock } from './components/widgets/automation-timeline-block';
import { AutomationTimelineSection } from './components/widgets/automation-timeline-section';
import {
  canEditApplicantAutomationOrgDefaults,
  canViewApplicantAutomations,
  canViewEmployeeAutomations,
} from './utils/automation-permission-utils';
import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

export const OrgProcessAutomations = ({
  org,
  jobs,
  selectedJob,
  focusApplicantAutomation,
}: {
  org: Org;
  jobs: Array<Job>;
  selectedJob?: Job;
  focusApplicantAutomation?: ApplicantAutomation | null;
}) => {
  const user = useSelector((state: any) => userSelector(state));

  const hasApplicantAutomationOrgDefaultEditPermission =
    canEditApplicantAutomationOrgDefaults(user);
  const hasApplicantAutomationViewPermission = canViewApplicantAutomations(user);
  const hasEmployeeAutomationViewPermission = canViewEmployeeAutomations(user);

  const noJobsForTimeline = jobs.length === 0;
  const disableApplicantAutomations =
    !hasApplicantAutomationViewPermission ||
    (!hasApplicantAutomationOrgDefaultEditPermission && noJobsForTimeline);

  return (
    <div className="u-margin-top-xl">
      <AutomationTimelineBlock
        title="Application Received"
        icon={<MaterialDesignIcon iconName={ICON_NAMES.POST_ADD} />}
        isFirst
      />
      <AutomationTimelineSection
        title="Application Process"
        sectionKey="application"
        org={org}
        editingForJob={selectedJob}
        disabled={disableApplicantAutomations}
        focusApplicantAutomation={focusApplicantAutomation}
      />
      <AutomationTimelineBlock
        title="Application Complete"
        icon={<MaterialDesignIcon iconName={ICON_NAMES.ASSIGNMENT_TURNED_IN} />}
      />
      <AutomationTimelineSection
        title="Hiring Process"
        sectionKey="hiring"
        org={org}
        editingForJob={selectedJob}
        disabled={disableApplicantAutomations}
        focusApplicantAutomation={focusApplicantAutomation}
      />
      <AutomationTimelineBlock
        title="Hiring Decision Made"
        icon={<MaterialDesignIcon iconName={ICON_NAMES.CHECK} />}
      />
      <AutomationTimelineSection
        title="Onboarding"
        sectionKey="onboarding"
        org={org}
        editingForJob={selectedJob}
        disabled={disableApplicantAutomations}
        focusApplicantAutomation={focusApplicantAutomation}
      />
      <AutomationTimelineBlock
        title="Employee Starts"
        icon={<MaterialDesignIcon iconName={ICON_NAMES.PERSON_ADD} className="u-margin-right-xs" />}
      />
      <AutomationTimelineSection
        title="Employee Tenure"
        sectionKey="employee"
        org={org}
        editingForJob={selectedJob}
        disabled={!hasEmployeeAutomationViewPermission}
      />
      <AutomationTimelineBlock
        title="Employee Terminated"
        icon={<MaterialDesignIcon iconName={ICON_NAMES.EXIT_TO_APP} />}
        isLast
      />
    </div>
  );
};
